import ky from 'ky'
import type { AfterResponseHook, BeforeRequestHook, Options } from 'ky'

import { createKyCacheHook } from '@tsyl/radon'

import { getAuth0 } from '../auth'

let token: string | null | undefined
const injectToken: BeforeRequestHook = async (request) => {
  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`)
  } else {
    try {
      const auth0 = await getAuth0()
      token = await auth0.getTokenSilently()
      request.headers.set('Authorization', `Bearer ${token}`)
    } catch (error) {
      console.warn('injectToken: failed to obtain access token silently', error)
    }
  }
}

export const removeTokenIfInvalid: AfterResponseHook = (request, options, response) => {
  if (response.status === 401) {
    token = null
  }
}

const config = {
  timeout: false as const,
  hooks: {
    beforeRequest: [injectToken],
    afterResponse: [removeTokenIfInvalid]
  },
  retry: { limit: 1 },
  prefixUrl: '/'
} satisfies Options

export const cacheHook = createKyCacheHook()

export default ky.create(config)
